import React from "react";
import {
  Backdrop,
  Button,
  EmployeeHeader,
  LogoLoader,
  NoData,
  PageHeader,
  showToast,
  TableAdv,
} from "../../../../components";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { fetchOneOnboarding } from "../../../../redux/slices/onboarding/onboardingApi";
import { useSelector } from "react-redux";
import { dateFormator, mapTableRows } from "../../../../utils";
import { fieldsToDroppedFieldsMapper } from "../../../../utils/wf/onboarding.helpers";
import { documentOnboardingStatus } from "../../../../assets/data/enumData";
import { getPresignedUrl } from "../../../../redux/slices/universal/fileUploadApi";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import ViewModal from "../../EOnboardingNew/Dashboard/ModalsAndDrawers/ViewModal";
import { useCallback } from "react";

const OnboardingDocuments = () => {
  const navigate = useNavigate();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { employeeProfileUiid } = useSelector((state) => state.employee);
  const [viewModalOpen, setViewModalOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [currentDocument, setCurrentDocument] = React.useState(false);
  const [data, setData] = React.useState({
    //overall onboarding document of specific employee
    onboardingDocument: {},
    // documents to display in the table
    onboardingDocuments: [],
  });
  console.log({ data });

  const fetchOnboardingDocuments = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetchOneOnboarding({
        uiid: employeeProfileUiid,
        ref: "Employee Checklist PdfTemplate",
        incl: ["firstName lastName email jobTitle mobile employmentType"],
      });
      const tableData =
        response?.data?.data?.checklists?.flatMap((checklist) =>
          (checklist.documents || []).map((data) => {
            const mappedFields = fieldsToDroppedFieldsMapper(data?.fields, data?.id?.fields)
            const normalizedMetaData = {
              ...data,
              id: {
                ...data.id,
                fields: mappedFields,
              },
            };
            return {
              documentTitle: data?.id?.name || "-",
              metaData: normalizedMetaData,
              checklistName: checklist?.id?.name || "-",
            };
          }),
        ) || [];
      setData((prev) => ({
        ...prev,
        onboardingDocument: response?.data?.data || {},
        onboardingDocuments: tableData,
      }));
      if (response.errorCode === 404)
        throw new Error("No Onboarding documents found");
      if (!response.success) throw new Error("Something Went Wrong!");
    } catch (error) {
      console.error({ error })
      showToast(
        error?.message ? error?.message : "Error fetching onboarding documents",
        "error",
      );
    }finally {
      setLoading(false);
    }
  }, [employeeProfileUiid]);

  useEffect(() => {
    fetchOnboardingDocuments();
  }, [employeeProfileUiid]);
  
  const handleViewOpener = async (row) => {
    try {
      setLoading(true);

      const docMetadata = row?.metaData?.id;
      const approversArray = row?.metaData?.approver;

      if (!docMetadata?.file) {
        showToast("No File Found!", "error");
        return;
      }

      const presignedUrl = await getPresignedUrl(docMetadata.file);
      const response = await fetch(presignedUrl, {
        mode: "cors",
      });
      const urlDataInBlob = await response.blob();
      const arrayBuffer = await urlDataInBlob.arrayBuffer();

      const documentForPreview = {
        onboardingInfo: row?.onboardingInfo,
        id: docMetadata._id,
        referenceId: docMetadata.templateId,
        documentName: docMetadata.name,
        category: docMetadata.category,
        type: docMetadata.type,
        description: docMetadata.description,
        toBeFilledBy: docMetadata.filledBy,
        createdBy: `User`,
        createdOn: docMetadata.addedOn,
        workflows: [
          {
            approvers: {
              label: docMetadata.approver,
              value: docMetadata.approver,
            },
            initiator: {
              label: docMetadata.initiator,
              value: docMetadata.initiator,
            },
          },
        ],
        arrayBuffer,
        pageCount: docMetadata.pageCount,
        droppedFields: docMetadata.fields || {},
        status: docMetadata.status,
        metaData: docMetadata,
        onboardingDocsApprover: approversArray,
      };
      setCurrentDocument(documentForPreview);
      setViewModalOpen(true);
    } catch (e) {
      console.error(
        "Error in handleViewOpener in src/pages/InnerPages/EOnboardingNew/Dashboard/ModalsAndDrawers/DashboardDrawer.jsx",
        e,
      );
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const applicantColumns = [
    {
      key: "documentTitle",
      label: "Document Title",
    },
    {
      key: "checklistName",
      label: "Checklist Name",
    },
    {
      key: "action",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-2">
        <Button
          size="sm"
          title={"View"}
          icon={"visibility"}
          type="icon"
          color="primary"
          variant="text"
          onClick={() => handleViewOpener(row)}
        />
        {/* <Button
          size="sm"
          title={"View"}
          icon={"download"}
          type="icon"
          color="primary"
          variant="text"
          onClick={() => showToast("In Progress")}
          />*/}
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(data?.onboardingDocuments, applicantColumns);
  
  const handleUpdateField = (fieldId, value, userId = null) => {
    if (!(currentDocument?.onboardingDocsApprover || [])?.includes(userId)) {
      showToast("You are not an Approver to fill details.", "warning", 5000);
      return;
    }
    setCurrentDocument((prevDoc) => {
      if (!prevDoc) return prevDoc;

      // const updatedFields = { ...prevDoc.droppedFields };
      const updatedFields = cloneDeep(prevDoc.droppedFields);
      let fieldFound = false;

      Object.keys(updatedFields).forEach((pageNum) => {
        updatedFields[pageNum] = updatedFields[pageNum].map((field) => {
          if (field.id !== fieldId) return field;

          fieldFound = true;
          if (!field.value || typeof field.value !== "object") {
            field.value = {};
          }
          field.value = value;

          return { ...field };
        });
      });

      if (!fieldFound) {
        console.warn(`Field ${fieldId} not found in document`);
      }

      return {
        ...prevDoc,
        droppedFields: updatedFields,
      };
    });
  };

  return (
    <>
    <div className="mt-3 flex-1 flex flex-col gap-2 ">
      <div>
        <PageHeader
          Section={<EmployeeHeader />}
          RightSection={
            <div className="flex gap-3">
              <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                type="link"
                to="/employee"
              />
              {/* <Button
                size="sm"
                title={"Back"}
                icon={"west"}
                // onClick={() => navigate("/employee/employee-profile#invoices")}
                onClick={() =>
                  navigate("/employee/employee-profile?profile-info=invoices")
                }
              /> */}
              {/* <Button
                size="sm"
                title={"Next"}
                icon={"east"}
                iconPosition="after"
              /> */}
            </div>
          }
        />
      </div>
      {/* Onboarding Documents */}
      <TableAdv
        columns={applicantColumns}
        rows={mappedRows}
        fixedCol={1}
        //
        serverPagination={true}
        totalCount={data?.onboardingDocuments?.length}
        // if server search
        // page={page}
        // limit={limit}
        // onPaginationChange={setPage}
        // onLimitChange={handleLimitChange}

        // searchConfig
        // serverSearchValue={searchValue}
        // serverOnSearch={handleSearch}
        toolbarRight={{
          search: false,
        }}
      />
      {/* <NoData />*/}
      <ViewModal
        document={currentDocument}
        setCurrentDocument={setCurrentDocument}
        onUpdateField={handleUpdateField}
        viewModalOpen={viewModalOpen}
        setViewModalOpen={setViewModalOpen}
        // setRejectApplicantModalOpen={setRejectApplicantModalOpen}
        // setVerifyModalOpen={setVerifyModalOpen}
        // setResendModalOpen={setResendModalOpen}
        loginUserUiid={loginUserUiid}
        actions={false}
      />
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </>
  );
};

export default OnboardingDocuments;
